import { Injectable } from "@angular/core";
import { createEffect } from "@ngrx/effects";
import { PlatformService, WindowRef } from "@obg/ngx.global";
import { fromEvent } from "rxjs";
import { map } from "rxjs/operators";

import { RouteAction } from "../store/route.action";
import { NavigateByUrlPayload, NavigatePayload } from "../store/route.model";

import { NAVIGATE_BY_NAME_EXTERNAL_EVENT_NAME, NAVIGATE_BY_URL_EXTERNAL_EVENT_NAME } from "./external-api.const";

/**
 * Exposes Angular's navigation.
 *
 * Example usages:
 * ```ts
 * document.dispatchEvent(new CustomEvent("obgNavigate", {
 *     detail: { routeName: "casino" }
 * }));
 *
 * document.dispatchEvent(new CustomEvent("obgNavigateByUrl", {
 *     detail: { url: "/en/casino" }
 * }));
 * ```
 */
@Injectable()
export class ExternalApiEffect {
	externalNavigate$ = this.platformService.forClient(() =>
		createEffect(() =>
			fromEvent<CustomEvent>(this.windowRef.native.document, NAVIGATE_BY_NAME_EXTERNAL_EVENT_NAME).pipe(
				map((event) => event.detail as NavigatePayload),
				map((payload) => RouteAction.navigate(payload.routeName, payload.params, payload.extras))
			)
		)
	);

	externalNavigateByUrl$ = this.platformService.forClient(() =>
		createEffect(() =>
			fromEvent<CustomEvent>(this.windowRef.native.document, NAVIGATE_BY_URL_EXTERNAL_EVENT_NAME).pipe(
				map((event) => event.detail as NavigateByUrlPayload),
				map((payload) => RouteAction.navigateByUrl(payload.url, payload.extras))
			)
		)
	);

	constructor(
		private platformService: PlatformService,
		private windowRef: WindowRef
	) {
		if (this.platformService.isBrowser) {
			(this.windowRef.native as any).obgNavigationSupported = true;
		}
	}
}
